import ButtonContainer from "@components/ButtonContainer";
import Select from "@components/EasyDev/form/Select";
import Loader from "@components/Loader";
import FileUpload from "@components/Shared/FileUpload";
import FormTextareaField from "@components/Shared/FormTextareaField";
import FormTextField from "@components/Shared/FormTextField";
import SelectedArtistDisplay from "@components/Shared/SelectedArtistsDisplay";
import useGetSelectArtists from "@hooks/Artist/useGetSelectArtists";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field } from "react-final-form";
import { Col } from "reactstrap";
import styles from "./CreateForm.module.scss";

const CreateForm = ({ handleSubmit }: IFormProps): ReactElement => {
  const { data: artists, loading } = useGetSelectArtists();

  if (loading || !artists) {
    return <Loader isInsideThing />;
  }

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <Col md={6}>
        <div className="form__form-group">
          <span className="form__form-group-label">Name</span>
          <div className="form__form-group-field">
            <Field
              name="name"
              component={FormTextField}
              type="text"
              placeholder={"Partner's Name"}
              isAboveError
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Description</span>
          <div className="form__form-group-field">
            <Field
              name="description"
              component={FormTextareaField}
              type="text"
              placeholder={"Enter a Description"}
              isAboveError
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Order</span>
          <div className="form__form-group-field">
            <Field
              name="order"
              component={FormTextField}
              type="number"
              placeholder={"Enter Order"}
              isAboveError
            />
          </div>
        </div>

        <FileUpload title="Logo" isSingle formFieldName="imageUrl" />

        <FileUpload title="Hero" isSingle formFieldName="heroImageUrl" />
      </Col>

      <Col md={6}>
        <div className="form__form-group">
          <span className={styles.artist}>Select Artists</span>
          <div className="form__form-group-field">
            <Field
              name="artist"
              component={Select}
              placeholde="Enter Artist"
              isAboveError
              options={artists}
            />
          </div>
        </div>

        <SelectedArtistDisplay />
      </Col>

      <ButtonContainer />
    </form>
  );
};

export default CreateForm;
